import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

import { Severity } from '@wdx/shared/utils';
import {
    WdxIconButtonSize,
    WdxIconButtonStyle,
} from './wdx-icon-button.component.interface';

/**
 * @deprecated This component as been deprecated and replaced by `WdxButtonDirective` -> `button[wdxIconButton]` | `a[wdxIconButton]`
 */
@Component({
    selector: 'wdx-icon-button',
    templateUrl: './wdx-icon-button.component.html',
    styleUrls: ['./wdx-icon-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    host: { class: 'd-inline-block' },
})
export class WdxIconButtonComponent {
    @Input() size: WdxIconButtonSize = 'md';
    @Input() overflowVisible = false;
    @Input() positionRelative = false;
    @Input() wdxStyle: WdxIconButtonStyle = '';
    @Input() disabled?: boolean;
    @Input() severity?: Severity;
    @Input() buttonTitle!: string;
    @Input() buttonAriaLabel = '';

    @Output() wdxOnClick = new EventEmitter<MouseEvent>();

    onClick(event: MouseEvent): void {
        this.wdxOnClick.emit(event);
    }
}
